import type { BnbSettingsType } from "../redux/reducers/BnbSettingsReducer";
import { NavStep } from "../../shared-logic/utils/Navigation";

export const isMergedEngineStep = (bnbSettings: BnbSettingsType, step: NavStep): boolean => {
    return !!bnbSettings.showMergedModelStep && step === NavStep.Model;
};
